import Link from "next/link";
import React from "react";

export interface LoginRegisterLayoutProps {
  logo: React.ReactNode;
  form: React.ReactNode;
}

const LoginRegisterLayout: React.FC<LoginRegisterLayoutProps> = ({
  logo,
  form,
}) => {
  return (
    <div className="relative flex min-h-screen w-full flex-col bg-gradient-to-b from-mono-00 to-sifted-40 lg:justify-center">
      <div className="mb-4 mt-4 grid h-10 place-items-center md:mb-10 md:mt-10 md:grid-cols-6 lg:grid-cols-12">
        <Link href="/" className="h-full md:col-start-2 ">
          {logo}
        </Link>
      </div>

      <div className="flex grow items-start justify-center lg:pt-0">{form}</div>
    </div>
  );
};

export default LoginRegisterLayout;
